import React, { useEffect, useMemo } from 'react'
import MainSlideCard from '../../cards/MainSlideCard'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import { getMainSlider } from '../../../services/actions/MainAction';

import img1 from "../../../assets/images/slide_img_1.jpg";
import img2 from "../../../assets/images/slide_img_2.jpg";
import img3 from "../../../assets/images/slide_img_3.jpg";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 764 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 764, min: 0 },
    items: 1
  }
};
function MainSection() {
  const dispatch = useDispatch();
  const lang_id = useSelector(state => state.Data.lang_id);
  const mainSlider = useSelector(state => state.Data.mainSlider);

  useEffect(()=>{
    // dispatch(getMainSlider(lang_id))
  },[lang_id])
  const sliderData = useMemo(()=>{
    return [
      {
        image_full_url: img1
      },
      {
        image_full_url: img2
      },
      {
        image_full_url: img3
      },
    ]
  },[])
  return (
    <div className='h-[calc(100vh_-_150px)] w-full relative max-[1000px]:h-auto min-h-[200px]'>
       <div  className='absolute bg-[red] z-[300] bg-black/40 w-full h-full top-0 left-0 flex justify-center items-start flex-col'>
           <div className='w-[1700px] max-[1700px]:w-full max-[1700px]:pl-[40px] ml-auto mr-auto flex max-[600px]:justify-center max-[600px]:pl-0'>
             <h1 className='text-white bg-[--red] text-[38px] font-[800] p-[10px_20px] max-[500px]:text-[20px] '>Elektrik Xidmətləri</h1>
           </div>
            {/* <p className='text-white mt-[20px] max-[500px]:mt-[0] text-[25px] max-w-[700px] text-center max-[1000px]:text-[20px] max-[700px]:text-[16px] max-[500px]:text-[14px] max-[300px]:text-[12px]'>{data?.translate?.text}</p> */}
        </div>
       <Carousel 
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr={true} 
          
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          customTransition="all 2s"
          transitionDuration={2000}
          containerClass="h-full"
          dotListClass="custom-dot-list-style"
          itemClass=""
          
        >
          {
            sliderData?.map((data, i) => {
              return (
                <MainSlideCard key={i} data={data} />
              )
            })
          }
        </Carousel>
      
    </div>
  )
}

export default MainSection